export default "__VITE_ASSET__Cq6NZ9Cv__"